// import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportEmployee from '@/pages/report-employee-sales/ReportEmployeeSales'

export default [
  {
    path: '/report-employee-sales/:userToken/:date',
    name: 'ReportEmployeeSales',
    component: ReportEmployee,
    meta: {
      hideMainMenu: true,
      isFromApp: false,
      role: {
        sectorId: 'public',
      },
    }
  },
  {
    path: '/report-employee-sales/:userToken/:date/fapp',
    name: 'ReportEmployeeSalesFapp',
    component: ReportEmployee,
    meta: {
      hideMainMenu: true,
      isFromApp: true,
      role: {
        sectorId: 'public',
      },
    }
  }
]